export const blockIconsHardwareDeviceThermostatNew = (
	<span className='material-symbols-outlined'>device_thermostat</span>
);
